var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGidchv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2015,
    cy: 27.2279,
    r: 26.4623,
    fill: "#475EFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6117 19.3816L27.2008 27.2425L40.79 19.3816M27.2008 42.9175V27.2269M41.2103 33.4533V21.0005C41.2097 20.4546 41.0656 19.9184 40.7924 19.4457C40.5192 18.973 40.1265 18.5805 39.6537 18.3076L28.7574 12.0812C28.2842 11.8079 27.7473 11.6641 27.2008 11.6641C26.6544 11.6641 26.1175 11.8079 25.6442 12.0812L14.748 18.3076C14.2752 18.5805 13.8825 18.973 13.6093 19.4457C13.3361 19.9184 13.192 20.4546 13.1914 21.0005V33.4533C13.192 33.9993 13.3361 34.5355 13.6093 35.0081C13.8825 35.4808 14.2752 35.8733 14.748 36.1462L25.6442 42.3727C26.1175 42.6459 26.6544 42.7898 27.2008 42.7898C27.7473 42.7898 28.2842 42.6459 28.7574 42.3727L39.6537 36.1462C40.1265 35.8733 40.5192 35.4808 40.7924 35.0081C41.0656 34.5355 41.2097 33.9993 41.2103 33.4533Z",
    stroke: "white",
    strokeWidth: 3.11321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGidchv);
export default __webpack_public_path__ + "static/media/gói dịch vụ.cd81329b51e3d27bd813526755afd0e4.svg";
export { ForwardRef as ReactComponent };